import React from "react";

export const CHAT_COPY = {
  ro: {
    open: "Întreabă-ne",
    title: "Asistent Marioway",
    sub: "Răspund în română, engleză sau spaniolă",
    placeholder: "Scrie întrebarea ta…",
    welcome: "Bună! 👋 Sunt asistentul Marioway. Te pot ajuta cu Universal Credit, EUSS, taxe, Student Finance și alte acte UK. Cu ce te pot ajuta azi?",
    chips: ["Cum aplic pentru Universal Credit?", "Ce e EUSS și cum îmi verific statusul?", "Vreau o programare"],
    error: "Asistentul nu e disponibil momentan. Scrie-ne pe WhatsApp: 07383513170.",
    disclaimer: "Informații generale, nu consultanță juridică. Suport administrativ independent.",
  },
  en: {
    open: "Ask us",
    title: "Marioway Assistant",
    sub: "I reply in English, Romanian or Spanish",
    placeholder: "Type your question…",
    welcome: "Hi! 👋 I'm the Marioway assistant. I can help with Universal Credit, EUSS, taxes, Student Finance and other UK paperwork. How can I help today?",
    chips: ["How do I apply for Universal Credit?", "What is EUSS and how do I check my status?", "I want to book a consultation"],
    error: "The assistant is unavailable right now. Message us on WhatsApp: 07383513170.",
    disclaimer: "General information, not legal advice. Independent administrative support.",
  },
};

export const getSessionId = () => {
  let sid = localStorage.getItem("mw_chat_sid");
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem("mw_chat_sid", sid);
  }
  return sid;
};

export const readSse = async (res, onEvent) => {
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) return;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    parts.filter((p) => p.startsWith("data: ")).forEach((p) => onEvent(JSON.parse(p.slice(6))));
  }
};

const PHONE = "07383513170";

const linkPhone = (text) =>
  text.split(/(07383513170)/).map((s, j) =>
    s === PHONE ? (
      <a key={`${s}-${j}`} href="https://wa.me/447383513170" target="_blank" rel="noopener noreferrer" className="underline font-bold">{s}</a>
    ) : (
      s
    )
  );

export const renderText = (text) =>
  text.split("**").map((part, i) =>
    i % 2 === 1 ? <strong key={`b-${i}-${part.slice(0, 12)}`}>{part}</strong> : <React.Fragment key={`t-${i}-${part.slice(0, 12)}`}>{linkPhone(part)}</React.Fragment>
  );
